
import { logger } from '@/services/LoggingService';

/**
 * Cleans up connection success parameters from the URL
 * without losing other important query parameters
 */
export function cleanupConnectionSuccessParams() {
  try {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    
    // Save important parameters we want to keep
    const retainedParams = new URLSearchParams();
    
    // Parameters to remove - removed connection_id
    const paramsToRemove = ['success', 'account', 'timestamp'];
    
    // Copy all parameters except those we want to remove
    params.forEach((value, key) => {
      if (!paramsToRemove.includes(key)) {
        retainedParams.set(key, value);
      }
    });
    
    // Build the new URL string
    const newSearch = retainedParams.toString();
    const newUrl = `${window.location.pathname}${newSearch ? '?' + newSearch : ''}`;
    
    logger.info('cleanupConnectionSuccessParams', 'Cleaning URL parameters', { 
      oldUrl: window.location.href,
      newUrl,
      removedParams: paramsToRemove
    });
    
    // Replace the URL without reloading the page
    window.history.replaceState({}, '', newUrl);
  } catch (err) {
    logger.error('cleanupConnectionSuccessParams', 'Error cleaning up URL parameters', { 
      error: err instanceof Error ? err.message : String(err) 
    });
  }
}

/**
 * Clean up callback parameters from URL
 * Used after processing callbacks
 */
export function cleanupCallbackParams(): void {
  try {
    // Get current URL
    const url = new URL(window.location.href);
    const params = url.searchParams;
    
    // Parameters to clean up - removed provider
    const paramsToClean = [
      'code', 
      'account',
      'state', 
      'error', 
      'message'
    ];
    
    // Remove each parameter
    paramsToClean.forEach(param => {
      if (params.has(param)) {
        params.delete(param);
      }
    });
    
    // Create clean URL
    const cleanUrl = url.pathname + (params.toString() ? `?${params.toString()}` : '');
    
    // Update browser history without navigation
    window.history.replaceState({}, '', cleanUrl);
    
    logger.info('cleanupCallbackParams', 'Cleaned up callback URL parameters', {
      originalUrl: window.location.href,
      cleanUrl
    });
  } catch (err) {
    logger.error('cleanupCallbackParams', 'Error cleaning up callback parameters', {
      error: err instanceof Error ? err.message : String(err)
    });
  }
}
